<template>
  <div id="login-page" class="relative mx-auto h-full w-full max-w-screen-md p-8 md:p-0">
    <div class="pt-32 mx-auto max-w-sm">
      <v-form
        ref="form"
        v-if="!successState"
        class="elevation-6 p-4 rounded-md white "
        lazy-validation
      >
        <v-text-field
          v-model="email"
          autocomplete="false"
          class="mb-2"
          label="E-mail"
          required
          variant="outlined"
          :rules="emailRules"
        ></v-text-field>

        <v-btn
          :disabled="!email"
          color="primary"
          @click="sendResetLinkToEmail"
        >
          Send reset link
        </v-btn>


      </v-form>
      <div v-else class="elevation-6 px-4 pt-7 pb-4 rounded-md text-center border-green-500">
          <h1 class="text-xl text-green-600">Password reset link sent to your email!</h1>
          <p class="text-sm">Please check your inbox</p>
      </div>
    </div>
    <v-snackbar v-model="errorState" color="error" timeout="3000">
      {{ errorStateText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="errorState = false"
        >
            Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ForgotPassword',
  data() {
    return {
      valid: false,
      email: '',
      emailRules: [
        (v: string) => !!v || 'E-mail is required',
        (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      validating: false,
      successState: false,
      errorState: false,
      errorStateText: 'Something went wrong. Please try again.',
    };
  },
  created() {
    this.$eventBus.on('emit-error', this.setErrorState);

    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    async sendResetLinkToEmail() {
      const data = await this.$store.dispatch('forgotPassword', {email: this.email});

      if (!!data && data.status) {
        this.successState = true;
      } else {
        this.$eventBus.emit('emit-error', { state: true, text: data.message ?? this.errorStateText });
      }
    },

    setErrorState({ state, text }) {
      this.errorState = state;
      if (text || text === '') { this.errorStateText = text; }
      else { this.errorStateText = 'Something went wrong. Please try again.'; }
    },
  },
});
</script>

<style scoped>

</style>
